class TeamStorePasswordGate extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('[data-team-store-password-input]');
    this.error = this.querySelector('[data-team-store-password-error]');

    this.form?.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const expectedHash = (this.dataset.passwordHash || '').trim().toLowerCase();
    const accessKey = this.dataset.accessKey || '';
    const returnTo = this.dataset.returnTo || window.location.pathname;
    const password = this.input?.value || '';

    if (!accessKey || !password) {
      this.showError();
      return;
    }

    let accessValue = password;

    if (expectedHash) {
      let enteredHash;
      try {
        enteredHash = await this.hashPassword(password);
      } catch (error) {
        this.showError();
        return;
      }

      if (enteredHash !== expectedHash) {
        this.showError();
        return;
      }

      accessValue = expectedHash;
    }

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [accessKey]: accessValue,
          },
        }),
      });
    } catch (error) {
      this.showError();
      return;
    }

    window.location.href = returnTo;
  };

  async hashPassword(password) {
    const data = new TextEncoder().encode(password);
    const digest = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(digest))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  showError() {
    if (this.error) {
      this.error.hidden = false;
    }

    this.input?.setAttribute('aria-invalid', 'true');
    this.input?.focus();
  }
}

if (!customElements.get('team-store-password-gate')) {
  customElements.define('team-store-password-gate', TeamStorePasswordGate);
}
